import {multiVillageKeyValue} from "../shared/constants";
import {Village} from "../shared/interfaces/village";

export interface IUserService {
  getSelectedVillage: () => Village | null;
  setSelectedVillage: (village: Village | null) => void;
  isMultiVillageOptionSelected: () => boolean;
}

export class UserService implements IUserService {
  private _selectedVillage: Village | null;

  constructor() {
    this._selectedVillage = null;
  }

  public getSelectedVillage = () => this._selectedVillage;

  public setSelectedVillage = (village: Village | null) => {
    this._selectedVillage = village;
  };

  public isMultiVillageOptionSelected(): boolean {
    return this._selectedVillage?.id === multiVillageKeyValue.value;
  }
}
